import usePrivateAxios from "@/common/api/usePrivateAxios"
import { getRailsUpdate } from "@/common/utils/getRailsUpdate"
import { mapToDeletion } from "@/common/utils/railsHelpers"
import { EstablishmentLeadsFunnelUpdateValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { EstablishmentLeadData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { useMutation } from "@tanstack/react-query"

interface UseUpdateEstablishmentLeadMaintenanceModelsProps {
  id?: string
  establishmentLead: EstablishmentLeadData
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateEstablishmentLeadMaintenanceModels = ({
  id,
  establishmentLead,
  onSuccess,
  onError,
}: UseUpdateEstablishmentLeadMaintenanceModelsProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentLeadMaintenanceModels'],
    mutationFn: (data: EstablishmentLeadsFunnelUpdateValidationSchema) => {
      const payload = {
        maintenance_infrastructures_attributes: getRailsUpdate(
          establishmentLead.maintenance_infrastructures || [],
          data.maintenance_infrastructures || [],
          (x) => x.infrastructure_id,
          (y) => y.value,
          mapToDeletion,
          (z) => ({ infrastructure_id: z.value }),
        ),
        maintenance_technical_professionals_attributes: getRailsUpdate(
          establishmentLead.maintenance_technical_professionals || [],
          data.maintenance_technical_professionals || [],
          (x) => x.technical_professional_id,
          (y) => y.value,
          mapToDeletion,
          (z) => ({ technical_professional_id: z.value }),
        ),
      }

      return privateAxios.put(`/funnel/establishment/leads/${id}/update_maintenance_models`, {
        lead: payload,
      })
    },
    onSuccess,
    onError,
  })
}
